import { useEffect, useMemo, useState } from 'react';
import createPublicProject from '../../../common/api/createVideo';

export function useImportPublicProject(
  apolloClient: any,
  organisationId: string,
  flags: any,
  shootstaAI: boolean
) {
  const { publicProjectId } = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return {
      publicProjectId: params.get('publicProjectId')
    };
  }, []);

  const hasImportParams = !!publicProjectId;
  const [loading, setLoading] = useState(hasImportParams);
  const [videoId, setVideoId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const importProject = async () => {
    const submittedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const workflowVersion = flags?.workflowV5 ? 5 : 4;

    setLoading(true);
    setError(null);

    try {
      const importRes = await apolloClient.mutate({
        ...createPublicProject(organisationId),
        variables: {
          organisationId,
          input: {
            name: 'Imported Project',
            projectType: 'VIDEO',
            submittedTimezone,
            workflowVersion,
            publicProjectId
          }
        },
        context: { module: 'video' }
      });

      const newVideoId = importRes?.data?.createVideo?.videoId;

      if (!newVideoId) throw new Error('createVideo returned no videoId');
      setVideoId(newVideoId);
    } catch (err) {
      setError('Import failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasImportParams) {
      setLoading(false);
      return;
    }
    importProject();
  }, [apolloClient, organisationId, flags, shootstaAI]);

  return { loading, videoId, error, setError, setLoading, importProject };
}
